<template>
  <div>
    <el-row>
      <div class="mb-10">
        <span class="filter-label">警示日期: </span>
        <el-date-picker
          v-model="dateRange"
          size="small"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="開始日期"
          end-placeholder="結束日期">
        </el-date-picker>
      </div>
      <el-col class="mb-10">
        <el-button
          size="small"
          type="primary"
          @click="getAlarmProfile()"
        >
          查詢
        </el-button>
        <el-button
          size="small"
          type="warning"
          icon="el-icon-download"
          @click="handleExport()"
        >
        匯出
        </el-button>
      </el-col>
    </el-row>

    <!-- table -->
    <el-table 
      v-loading="listLoading"
      :data="noteList" style="width: 100%;" 
      :cell-style="{padding: '0', height: '40px'}"
      @sort-change="tableSortChange"
     >
      <el-table-column align="center" label="警示日期">
        <template slot-scope="scope">
          {{ scope.row.openedOn ? $moment(scope.row.openedOn).format('YYYY-MM-DD') : '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="type.note" label="異常值"/>
      <el-table-column align="center" prop="waterNum" label="水號"/>
      <el-table-column align="center" prop="meterNum" label="表號"/>
      <el-table-column align="center" prop="alias" label="用戶別名"/>
      <el-table-column align="center" prop="address" label="地址"/>
      <el-table-column align="center" label="電子郵件1">
        <template slot-scope="scope">
          {{ scope.row.notifyMails && scope.row.notifyMails[0] ? scope.row.notifyMails[0] : '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="電子郵件2">
        <template slot-scope="scope">
          {{ scope.row.notifyMails && scope.row.notifyMails[1] ? scope.row.notifyMails[1] : '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="電子郵件3">
        <template slot-scope="scope">
          {{ scope.row.notifyMails && scope.row.notifyMails[2] ? scope.row.notifyMails[2] : '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="電子郵件4">
        <template slot-scope="scope">
          {{ scope.row.notifyMails && scope.row.notifyMails[3] ? scope.row.notifyMails[3] : '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="電子郵件5">
        <template slot-scope="scope">
          {{ scope.row.notifyMails && scope.row.notifyMails[4] ? scope.row.notifyMails[4] : '' }}
        </template>
      </el-table-column> 
      <el-table-column align="center" label="聯絡電話">
        <template slot-scope="scope">
          {{ scope.row.notifyPhones && Array.isArray(scope.row.notifyPhones) && scope.row.notifyPhones.length > 0 ? scope.row.notifyPhones.join(", ") : '' }}
        </template>
      </el-table-column>
    </el-table>

    <!--分頁組件-->
    <pagination v-show="total>0" :total="total" :current.sync="paginationSelectedPage" :size.sync="listQuery.size" @pagination="getAlarmProfile"/>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { mixins } from '@/views/common/mixins.js'
import _ from 'lodash'

export default {
  // 異常案件類型列表
  name: 'GroupAlarmList',
  components: {
    Pagination
  },
  mixins: [mixins], 
  data() {
    return {
      total: 0,
      dateRange: [this.$moment().format('YYYY-MM-DD'), this.$moment().add(1 , 'day').format('YYYY-MM-DD')],
      waterIdList:[],
      noteList:[],
      listLoading: false,
      queryAlarmHistory: {
        start: this.$moment().format('YYYY-MM-DD'), // StartDate取目前時間
        end: this.$moment().add(1 , 'day').format('YYYY-MM-DD') // EndDate取目前時間的隔天，這樣才會包含今天的資料
      },
      listQuery: {
        page: 0, // jpa pageIndex起始從0開始，但Pagination從1開始，透過watch paginationSelectedPage同步
        size: 5
      },
      paginationSelectedPage: 1, // 需配合Pagination元件與listQuery使用
    };
  },
  watch: {
    paginationSelectedPage: {
      handler: function(newValue) {
        this.listQuery.page = newValue - 1
      }
    },
    dateRange: function(val) {
      if (val) {
        this.queryAlarmHistory.start = val[0]
        this.queryAlarmHistory.end = val[1]
      } else {
        this.queryAlarmHistory.start = undefined
        this.queryAlarmHistory.end = undefined
      }
    }
  },
  async created(){
    await this.getProfile() // 取得水號列表
    this.getAlarmProfile() // 取得異常案件類型列表
  },
  methods: {
    async getProfile() {
      this.listLoading = true
      await this.axios.get('/api/system/profile?size=9999').then(res => {
        if(_.isArray(res.data.content))
        {
          let list = res.data.content
          let waterIdList = []
          list.forEach(item => {
            waterIdList.push(item.waterId)
          })
          this.waterIdList = waterIdList
        }
      })
      return
    },
    getAlarmProfile() {
      this.listLoading = true
      const params = {
        ...this.queryAlarmHistory,
        waterId: this.waterIdList.join(','),
        page: this.listQuery.page,
        size: this.listQuery.size
      };
      this.axios.get('/api/report/profile/alarmByWaterIds', {params: params}).then(res => {
        this.total = res.data.totalElements
        if(_.isArray(res.data.content))
        {
          this.noteList = res.data.content
        } else {
          this.noteList = []
        }
        this.listLoading = false
      })
    },
    // 匯出
    handleExport() {
      const params = {
        ...this.queryAlarmHistory,
        waterId: this.waterIdList.join(',')
      };
      const url = '/api/report/profile/alarm/exportGroup'
      this.axios({
        method: "get",
        url: url,
        responseType: "blob", // 設置 responseType 為 'blob'，以處理二進制檔案數據
        params: params
      }).then((response) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a")
        link.href = downloadUrl
        const fileName = `group-alarm.ods`
        link.setAttribute("download", fileName) // 設置下載檔案的名稱和副檔名
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.$message({
          showClose: true,
          message: '匯出成功',
          type: 'success',
          duration: 3000
        })
      })
      .catch((error) => {
        console.error("Error:", error);
        this.$message({
          message: '匯出失敗',
          type: 'error'
        })
      });
    }
  }
}
</script>